export default function CTAFinal() {
  return (
    <section className="py-24 md:py-32 relative overflow-hidden" style={{ background: 'linear-gradient(135deg, #0c1a2e 0%, #0f2744 100%)' }}>
      <div className="absolute inset-0" style={{ background: 'radial-gradient(ellipse at 50% 50%, rgba(14,165,233,0.12) 0%, transparent 70%)' }}></div>

      <div className="max-w-4xl mx-auto px-6 md:px-10 text-center relative z-10">
        <span className="inline-block text-xs font-bold tracking-widest uppercase text-sky-400 mb-6">Pronto para começar?</span>
        <h2 className="text-3xl md:text-5xl font-bold text-white leading-tight mb-6">
          Leve mais precisão e tecnologia para seus cálculos trabalhistas.
        </h2>
        <p className="text-white/60 text-base md:text-lg leading-relaxed mb-10 max-w-2xl mx-auto">
          Junte-se a centenas de advogados e escritórios que já confiam na Exato Cálculos para entregar resultados com mais agilidade, segurança e inteligência.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#contato"
            onClick={(e) => { e.preventDefault(); document.getElementById('contato')?.scrollIntoView({ behavior: 'smooth' }); }}
            className="px-9 py-4 rounded-xl text-white font-semibold text-base cursor-pointer whitespace-nowrap transition-all duration-200 hover:-translate-y-1"
            style={{ background: 'linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)' }}
          >
            <span className="inline-flex items-center gap-2">
              <i className="ri-send-plane-line"></i>
              Solicitar proposta
            </span>
          </a>
          <a
            href="#contato"
            onClick={(e) => { e.preventDefault(); document.getElementById('contato')?.scrollIntoView({ behavior: 'smooth' }); }}
            className="px-9 py-4 rounded-xl text-white font-semibold text-base cursor-pointer whitespace-nowrap border border-white/30 bg-white/10 hover:bg-white/20 transition-all duration-200"
          >
            <span className="inline-flex items-center gap-2">
              <i className="ri-phone-line"></i>
              Entrar em contato
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}
